import type { SVGProps } from "react";
export interface WatchHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WatchHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WatchHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.933 18.644a1.125 1.125 0 0 1 2.134.712l-.544 1.633a3.12 3.12 0 0 1-2.964 2.136h-3.117c-1.345 0-2.54-.86-2.965-2.136l-.545-1.634-.03-.11a1.125 1.125 0 0 1 2.123-.708l.043.107.543 1.633c.12.357.454.598.83.598h3.118c.376 0 .71-.241.83-.598zm-.976-11.27c.936 0 1.747.48 2.29 1.102.547.626.902 1.485.873 2.408l.002.002c-.037 1.226-.758 2.167-1.42 2.853l-.278.279c-.49.48-.96.925-1.365 1.302l-.98.895a1.615 1.615 0 0 1-2.04.098l-.118-.097c-.35-.313-.945-.854-1.633-1.509l-.715-.69c-.719-.702-1.656-1.73-1.698-3.131l.001-.002a3.53 3.53 0 0 1 .875-2.408c.543-.622 1.353-1.101 2.288-1.101.866 0 1.5.307 1.959.688.458-.381 1.093-.688 1.96-.688Zm0 2.25a.77.77 0 0 0-.587.23 1.4 1.4 0 0 0-.202.26l-.157.294v.002l-.025.044a1 1 0 0 1-.117.175q-.037.043-.079.082-.038.04-.08.075a1 1 0 0 1-.141.103l-.015.009q-.032.019-.066.036a1.1 1.1 0 0 1-.38.101 1.1 1.1 0 0 1-.475-.053l-.007-.001a1 1 0 0 1-.118-.047q-.034-.017-.067-.036l-.015-.01a1 1 0 0 1-.148-.106q-.028-.025-.055-.052a1.1 1.1 0 0 1-.182-.22l-.015-.023-.013-.029-.026-.048-.002-.002c-.097-.202-.2-.399-.357-.554a.77.77 0 0 0-.589-.23c-.148 0-.378.085-.593.332a1.3 1.3 0 0 0-.32.747l-.002.112v.005l.019.16c.073.38.372.812 1.003 1.43l.693.667c.439.418.84.786 1.159 1.077a74 74 0 0 0 1.853-1.745l.25-.253c.538-.567.761-.968.772-1.336v-.005l-.003-.112a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.593-.331ZM20 6.876c.621 0 1.125.504 1.125 1.125v2c0 .62-.504 1.124-1.125 1.124h-1A1.123 1.123 0 0 1 18.492 9 1.12 1.12 0 0 1 19 6.875h1Zm-6.44-6c1.344 0 2.537.861 2.963 2.137l.544 1.632a1.126 1.126 0 0 1-2.134.712l-.545-1.633a.875.875 0 0 0-.829-.598h-3.117a.88.88 0 0 0-.83.598l-.544 1.633a1.126 1.126 0 0 1-2.136-.712l.545-1.632.088-.234A3.13 3.13 0 0 1 10.442.875h3.117Z"
      />
      <path
        fill={color}
        d="M17.875 8c0-1.036-.84-1.875-1.876-1.875H8c-1.036 0-1.875.84-1.875 1.875v8c0 1.035.84 1.875 1.875 1.875h8c1.035 0 1.875-.84 1.875-1.876zm2.25 8a4.125 4.125 0 0 1-4.126 4.125H8a4.125 4.125 0 0 1-4.125-4.126V8A4.125 4.125 0 0 1 8 3.875h8A4.125 4.125 0 0 1 20.124 8v8Z"
      />
    </svg>
  );
}
